import { openkit } from "../../library/database";

export const searchBikes = async (category, pickupLocation, returnLocation) => {
  try {
    const query = {};
    category && (query.rbk_category = category);
    pickupLocation && (query.ren_pickup_loc = pickupLocation);
    returnLocation && (query.ren_return_loc = returnLocation);
    const resp = await openkit.custom.execute("post", "search-bikes", null, {
      query,
    });
    return resp;
  } catch (error) {
    console.log("error :>> ", error);
  }
};
